import { captureEvent } from '../../../../../services/event-capture';

export const trackExtendedForecastDayListCtaTapped = () => {
  captureEvent({
    type: 'Extended forecast: day list CTA tap',
    payload: {},
    sendToAmplitude: true,
  });
};

export const trackExtendedForecastCtaCardTapped = () => {
  captureEvent({
    type: 'Extended forecast: CTA card tap',
    payload: {},
    sendToAmplitude: true,
  });
};

export const trackExtendedForecastCtaPageViewed = () => {
  captureEvent({
    type: 'Extended forecast: CTA page viewed',
    payload: {},
    sendToAmplitude: true,
  });
};

export const trackExtendedForecastDayViewed = (payload: {
  date: string;
  dayLabel: string;
}) => {
  captureEvent({
    type: 'Extended forecast: extended day view',
    payload,
    sendToAmplitude: true,
  });
};
